import { Patient } from "./Patient";

export class ManualMeasurement {
    id: string = '';
    isMetricUnits: boolean = true;
    temperature: number | null = null;
    heartRate: number | null = null;
    respiratoryRate: number | null = null;
    spO2: number | null = null;
    patient: Patient | null = null;
    time: Date | null = null;
    remarks: string = '';
    labelId?: string;

    constructor(init?:Partial<ManualMeasurement>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);
        
        if (init.time) {
            this.time = new Date(init.time);
        }
    }

    validate() {
        if (this.temperature && this.temperature > 100) {
            throw new Error("Temperature cannot higher than 100");
        } 

        if (this.temperature && this.temperature < 0) {
            throw new Error("Temperature cannot lower than 0");
        }

        if (this.heartRate && this.heartRate > 300) {
            throw new Error("Heart rate cannot higher than 300");
        } 

        if (this.heartRate && this.heartRate < 0) {
            throw new Error("Heart rate cannot lower than 0");
        } 

        if (this.respiratoryRate && this.respiratoryRate > 300) {
            throw new Error("Respiratory rate cannot higher than 300");
        } 

        if (this.respiratoryRate && this.respiratoryRate < 0) {
            throw new Error("Respiratory rate cannot lower than 0");
        }

        if (this.spO2 && this.spO2 > 100) {
            throw new Error("SpO2 cannot higher than 100");
        } 

        if (this.spO2 && this.spO2 < 0) {
            throw new Error("SpO2 cannot lower than 0");
        }

        if (this.remarks && this.remarks.length > 3000) {
            throw new Error("Remarks is too long");
        }
    }

    normalize() {
        this.temperature = this.temperature && Math.round(this.temperature * 10) / 10;
        this.heartRate = this.heartRate && Math.round(this.heartRate);
        this.respiratoryRate = this.respiratoryRate && Math.round(this.respiratoryRate);
        this.spO2 = this.spO2 && Math.round(this.spO2 * 10) / 10;
    }
}
